export default __webpack_public_path__ + "css/adminQbo.bundle.css";